import React from 'react';
import { DisplayText, Dropdown } from '@superops/ui-design-system';
import { UserAssociation } from '../types';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

interface RequestorSelectorProps {
  userAssociations: UserAssociation[];
  selectedRequestor: UserAssociation | null;
  onRequestorChange: (requestor: UserAssociation | null) => void;
  associationsLoading: boolean;
}

const RequestorSelector: React.FC<RequestorSelectorProps> = ({
  userAssociations,
  selectedRequestor,
  onRequestorChange,
  associationsLoading
}) => {
  return (
    <div className="flex g20">
      <div className="flex actr g10">
        <SVGIcon name="Requester" />
        <div className="w200">
          <DisplayText size="large">
            <FormattedMessage id="mdm.settings.associatedRequester" />
          </DisplayText>
        </div>
      </div>
      <div className="w300">
        <Dropdown
          classNamePrefix="value_selector"
          options={userAssociations}
          value={selectedRequestor}
          onChange={(selectedOption: UserAssociation | null) => {
            onRequestorChange(selectedOption);
          }}
          placeholder={
            associationsLoading ? (
              <FormattedMessage id="common.label.loading" />
            ) : (
              <FormattedMessage id="mdm.settings.select.requester" />
            )
          }
          isLoading={associationsLoading}
          isDisabled={associationsLoading}
          isClearable={true}
          menuPlacement="auto"
          menuPosition="fixed"
        />
      </div>
    </div>
  );
};

export default RequestorSelector;
